import { getCurrentAuth } from "@/hooks/useAxiosPrivate";
import { isAdminToken } from "@/utils/userRole";

/**
 * Whether this tenant's build shows the Video Creator (HTPTV2-110, beta).
 *
 * A build flag, set in .env.dev, .env.nahl, .env.usah and .env.ssm: those are
 * the tenants with an analytics feed, and the editor is built from that feed's
 * highlights and reels. Anywhere else it would open onto games with nothing in
 * them.
 *
 * Read at call time for the same reason isSpotlightEnabled is: tests mutate
 * process.env directly.
 */
export function isVideoCreatorEnabled(): boolean {
  return process.env.REACT_APP_VIDEO_CREATOR === "true";
}

/**
 * Whether this viewer may use the Video Creator: admins only for now (HTP,
 * league and customer admins, the trio that gets the admin console).
 *
 * Read off the token rather than the profile, which is not there yet on a
 * reload and would send an admin away from the page they are on. Not the
 * security boundary: the AL API checks the same roles on every call.
 */
export function canUseVideoCreator(): boolean {
  return isAdminToken(getCurrentAuth()?.AccessToken);
}
